<div class="login-container">
  <div class="split-container">
    <!-- Left Panel - Hero Section -->
    <div class="left-panel">
      <div class="left-content">
        <div class="hero-badge">
          <span>🏆 Enterprise Lösung</span>
        </div>

        <h1 class="hero-title">
          <span class="hero-title-main">MSAR-Flow</span>
          <span class="hero-title-sub">Das All-in-One EAP System für Ihr Gewerbe</span>
        </h1>

        <p class="hero-description">
          Das komplette Enterprise-Resource-Planning System für Ihren E-Commerce. Von Kundenpflege
          bis Steuerarchiv – alles in einer Webanwendung. Optimiert für Desktop und Mobile.
        </p>

        <div class="hero-highlights">
          <div class="highlight-item">
            <span class="check">✓</span>
            <span>100% DSGVO‑konform</span>
          </div>
          <div class="highlight-item">
            <span class="check">✓</span>
            <span>eBay-Synchronisation</span>
          </div>
          <div class="highlight-item">
            <span class="check">✓</span>
            <span>Intuitive Workflows</span>
          </div>
        </div>

        <!-- Testimonial -->
        <div class="testimonial-card">
          <div class="testimonial-content">
            <p>
              "Mit MSAR-Flow spare ich jeden Monat Stunden an Verwaltungsaufwand. Absolute
              Empfehlung!"
            </p>
            <div class="testimonial-author">
              <strong>– Julia M., Gründerin</strong>
            </div>
          </div>
        </div>

        <!-- Partners -->
        <div class="partners-section">
          <h4>Integrationen</h4>
          <div class="partners-grid">
            <img src="/logos/dhl-logo.svg" alt="DHL" class="partner-logo" />
            <img src="/logos/ebay-logo.svg" alt="eBay" class="partner-logo" />
          </div>
        </div>
      </div>
    </div>

    <!-- Right Panel - Login Forms -->
    <div class="right-panel">
      <div class="right-content">
        <!-- Step 1: Login -->
        @if (step === 1) {
          <div class="login-card">
            <div class="card-header">
              <h2>Willkommen zurück 👋</h2>
              <p>Melden Sie sich in Ihrem MSAR~Flow-Konto an</p>
            </div>

            <form class="login-form" (ngSubmit)="onLogin()">
              <div class="input-group">
                <label for="email">E-Mail-Adresse</label>
                <input
                  type="email"
                  id="email"
                  name="mail"
                  [(ngModel)]="loginObj.mail"
                  placeholder="ihre.email@unternehmen.com"
                  required
                  class="form-input"
                />
              </div>

              <div class="input-group">
                <label for="password">Passwort</label>
                <input
                  type="password"
                  id="password"
                  [(ngModel)]="loginObj.password"
                  name="password"
                  placeholder="Ihr Passwort"
                  required
                  (keydown.enter)="onLogin()"
                  class="form-input"
                />
              </div>

              <button type="submit" class="btn btn-primary large">
                <span>Anmelden</span>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M5 12h14m-7-7l7 7-7 7"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
              </button>
            </form>

            <div class="security-note">
              <div class="security-icon">🔒</div>
              <span>Ihre Daten sind sicher – SSL 256-bit Verschlüsselung</span>
            </div>
          </div>
        }

        <!-- Step 2: 2FA -->
        @if (step === 2) {
          <div class="login-card">
            <div class="card-header">
              <h2>Zwei-Faktor-Authentifizierung</h2>
              <p>Geben Sie den 6-stelligen Code aus Ihrer Authenticator-App ein</p>
            </div>

            <form class="login-form" (ngSubmit)="verifyOtp()">
              <div class="input-group">
                <label for="otp">Sicherheitscode</label>
                <input
                  type="text"
                  id="otp"
                  name="otp"
                  [(ngModel)]="loginObj.otp"
                  maxlength="6"
                  placeholder="123456"
                  class="form-input otp-input"
                />
              </div>

              <button type="submit" class="btn btn-primary large">
                <span>Verifizieren</span>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M20 6L9 17l-5-5"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
              </button>
            </form>

            <div class="otp-help">
              <p>💡 <strong>Tipp:</strong> Der Code wird alle 30 Sekunden aktualisiert</p>
            </div>

            <div class="message-display" [class.error]="message && message.includes('Fehler')">
              {{ message }}
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
